import get from 'app/common/lib/get';
import api from 'app/actions/api';
import i18n from 'app/i18n';


export const LINK_REQUEST = 'eljur/LINK_REQUEST';
export const LINK_SUCCESS = 'eljur/LINK_SUCCESS';
export const LINK_FAILURE = 'eljur/LINK_FAILURE';

const linkRequest = () => ({
  type: LINK_REQUEST,
});

const linkSuccess = payload => ({
  type: LINK_SUCCESS,
  payload,
});

const linkFailure = payload => ({
  type: LINK_FAILURE,
  payload,
});

/**
* Запрос ссылки для перенаправления на Элжур
*/
export const eljurMakeLink = () => async (dispatch) => {
  dispatch(linkRequest());
  try {
    const res = await api('account/tokens/eljur/links/auth', 'get');
    dispatch(linkSuccess(get(res, ['data', 'url'], '')));
  } catch (error) {
    dispatch(linkFailure({ error, err: i18n.t('app:request_eljur_link_failed') }));
  }
};
